module.exports = __webpack_public_path__ + "static/media/add-circle-outline.d63e4972.svg";